import { MultiSelectFilters } from '@optimus-web/core';
import { ReservationsTableColumns } from '../../common';

export enum AdditionalColumns {
    ResourceCategoryName = 'ResourceCategoryName',
    CompanionNames = 'CompanionNames',
}

export type Columns = ReservationsTableColumns | AdditionalColumns;

export interface ReservationTableFilters {
    [ReservationsTableColumns.Classifications]?: MultiSelectFilters;
    [ReservationsTableColumns.Loyalty]?: MultiSelectFilters;
}

export type ReservationsTableState = Partial<Record<Columns, unknown>>;
